module.exports = __webpack_public_path__ + "static/img/Maple Oregano.bdb28e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Maple Oregano.jpg
// module id = 5yiD
// module chunks = 0